import { render, staticRenderFns } from "./tagInput-edit-material.vue?vue&type=template&id=654f1e5c&scoped=true&"
import script from "./tagInput-edit-material.vue?vue&type=script&lang=js&"
export * from "./tagInput-edit-material.vue?vue&type=script&lang=js&"
import style0 from "./tagInput-edit-material.vue?vue&type=style&index=0&id=654f1e5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654f1e5c",
  null
  
)

export default component.exports